// extracted by mini-css-extract-plugin
export default {"modal":"filter-modal_modal__9n2QA","container":"filter-modal_container__b0VCO"};